import * as React from 'react';
import TruncateMarkup from 'react-truncate-markup';
import { Image, Responsive } from '@cian/ui-kit';

import * as styles from './BankItem.css';

interface IBankItemProps {
  title: string;
  logo: string;
  bankId: number;
  onClick(): void;
}

export const BankItem: React.FC<IBankItemProps> = ({ title, logo, bankId, onClick }) => {
  return (
    <a
      href={`/skidki-i-akcii/all/?bank_ids=${bankId}`}
      className={styles['link']}
      onClick={onClick}
      data-testid="BankItem"
    >
      <div className={styles['logo']}>
        <Image src={logo} borderRadius="0" />
      </div>
      <Responsive desktop>
        <div className={styles['text']}>
          <TruncateMarkup lines={2}>
            <div>{title}</div>
          </TruncateMarkup>
        </div>
      </Responsive>
    </a>
  );
};
